const getVercelUrl = () =>
  process.env.VERCEL_URL ? `https://${process.env.VERCEL_URL}` : undefined;

const getServerFrontUrl = () => {
  if (process.env.VERCEL_ENV === 'preview') {
    const previewUrl = getVercelUrl();
    if (previewUrl) return previewUrl;
  }

  return (
    process.env.NEXTAUTH_URL ||
    getVercelUrl() ||
    process.env.NEXT_PUBLIC_FRONT_URL ||
    'http://localhost:3000'
  );
};

export const getFrontUrl = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }

  return getServerFrontUrl();
};
